import React from 'react';

import ScreenBody from '~/components/patterns/screens/parts/body/ScreenBody';
import ScreenLayout from '~/components/patterns/screens/basicScreen/layouts/ScreenLayout';

import useViewportType from '~/hooks/useViewportType';



type Props = {
	children: React.ReactNode,
	contentOverlay?: React.ReactNode,
	header: React.ReactElement,
	withPadding?: boolean,
};

const ScrollableContentScreen: React.FC<Props> = (props) => {
	const {
		children,
		contentOverlay,
		header,
		withPadding = true,
	} = props;

	const viewportType = useViewportType();

	return (
		<ScreenLayout
			contentOverlay={contentOverlay}
			header={header}
			// Phase 1 (horizontal navbar) removed - Phase 2 (vertical sidebar) is now default
			// Header fixed in Phase 2 and Phase 3 (not fixed only in very small viewports for mobile optimization)
			isHeaderFixed={!viewportType.isSmall}
		>
			{withPadding ? (
				<ScreenBody>
					{children}
				</ScreenBody>
			) : (
				children
			)}
		</ScreenLayout>
	);
};



export default ScrollableContentScreen;
